export default __webpack_public_path__ + "static/media/ajukan.f0b99c38.svg";